import React from "react";
import { observable, action } from "mobx";
import NotaFiscalTransporteService from "../../../../services/NotaFiscalTransporteService";
import { formatarDataCustomHTML } from "../../../../utils/formatar";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import { sortCaret } from "../../../comum/components/Icones";

export default class NotaFiscalTransporteStore {
  @observable dados = [];
  @observable colunas = [];
  @observable filtros = {};
  @observable loading = false;
  service = {};

  constructor() {
    this.service = new NotaFiscalTransporteService();
    this.filtros = {
      numeroNota: null,
      dataInicial: moment().subtract(1, "week").format("YYYY-MM-DD"),
      dataFinal: moment().format("YYYY-MM-DD")
    };
    this.colunas = [
      {
        dataField: "NumNotaTransp",
        text: "NOTA",
        headerStyle: { width: "10%", textAlign: "left" },
        sort: true,
        sortCaret: sortCaret
      },
      {
        dataField: "DtRecebtoEdi",
        text: "RECEBIMENTO",
        formatter: formatarDataCustomHTML,
        headerStyle: { width: "10%", textAlign: "left" },
        sort: true,
        sortCaret: sortCaret
      },
      {
        dataField: "MsgErro",
        text: "MENSAGEM",
        headerStyle: { minWidth: "20%", textAlign: "left" },
        formatter: (cell, row) => {
          const classe = row.StatusEdi.toUpperCase();

          return (
            <div style={classe === "ERRO" ? { color: "#EB502E" } : null}>
              {cell}
            </div>
          );
        }
      },
      {
        dataField: "EmailRemetEdi",
        text: "E-MAIL REMETENTE",
        headerStyle: { minWidth: "20%", textAlign: "left" }
      },
      {
        dataField: "EmailDestErro",
        text: "E-MAIL ERRO",
        headerStyle: { minWidth: "20%", textAlign: "left" }
      },
      {
        dataField: "StatusEdi",
        text: "SITUAÇÃO",
        headerStyle: { minWidth: "15%" },
        style: { textAlign: "center" },
        formatter: (cell, row) => {
          const classe = row.StatusEdi.toLowerCase();
          return <div className={`situacao-btn ${classe}`}>{cell}</div>;
        }
      }
    ];
  }

  listar() {
    this.loading = true;
    this.service
      .listarEdiNf(
        this.filtros.numeroNota,
        this.filtros.dataInicial,
        this.filtros.dataFinal
      )
      .then(response => (this.dados = response.data))
      .catch(erro => console.log("NotaFiscalTransporteStore.listar:", erro))
      .finally(() => (this.loading = false));
  }
}



// WEBPACK FOOTER //
// ./src/modules/nota-fiscal-transporte/edi/stores/NotaFiscalTransporteStore.js